export const nonDraftStates:string[] = ["published", "publishing", "unpublishing", "unpublishfailed"];

export const uneditableStates:string[] = ["publishing", "unpublishing"];

export const searchOptions: string[] = ["propertyName", "propertyRecordName", "stateOrProvince", "street", "street2", "postalCode", "city", "propertyType"];
